/**
 * Website "Tech stack": sidebar tabs with a fade between content grids.
 */
document.addEventListener('DOMContentLoaded', function () {
    var tabItems = document.querySelectorAll('.tech-stack__sidebar .tab-item');
    var contentGrids = document.querySelectorAll('.tech-stack__content-grid');

    tabItems.forEach(function (tab) {
        tab.addEventListener('click', function () {
            tabItems.forEach(function (t) { t.classList.remove('active'); });
            contentGrids.forEach(function (g) {
                g.style.opacity = '0';
                setTimeout(function () { g.style.display = 'none'; }, 300);
            });

            this.classList.add('active');

            var targetGrid = document.getElementById(this.getAttribute('data-target'));
            if (targetGrid) {
                setTimeout(function () {
                    targetGrid.style.display = ''; // fall back to CSS rules
                    void targetGrid.offsetWidth; // reflow so the transition runs
                    targetGrid.style.opacity = '1';
                }, 300);
            }
        });
    });
});
